

















import Vue from 'vue'
import { setEndDate, setStartDate } from '../store/actions';
import { routerReplace } from '../helpers';
import { ITranslations } from '../store/state';
import { EventBus } from '../helpers/EventBus.vue';

interface DateFilterData {
}

interface DateFilterMethods {
    toTop(): void,
}

interface DateFilterComputed {
    startDate: string,
    endDate: string,
	translations: ITranslations
}

export default Vue.extend<DateFilterData, DateFilterMethods, DateFilterComputed , {}>({
	name: 'DateFilter',
    computed: {
        startDate: {
            set(value) {
                this.$store.dispatch(setStartDate(value))
                routerReplace({
                    query: this.$store.getters.getParams
                })
            },
            get() {
                return this.$store.getters.date.start
            }
        },
        endDate: {
            set(value) {
                this.$store.dispatch(setEndDate(value))
                routerReplace({
                    query: this.$store.getters.getParams
                })
            },
            get() {
                return this.$store.getters.date.end
            }
        },
        translations() {
			return this.$store.getters.translations
		}
    },
    methods: {
        toTop() {
            //let filter close before scroll
            setTimeout(() => EventBus.$emit('scrollToTop'), 50)
        }
    }
})
